<template>
  <section
    v-if="data"
    :class="$style.root"
  >
    <div :class="$style.content">
      <PagesProjectsRefactorSlugComponent :data="data" />
    </div>
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>


<script lang="ts" setup>
const getAttributes = baseStrapiGetAttributes

// 1
useHead({
  htmlAttrs: { 'data-page-type': 'projects-slug' }
})

// 2
const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryProjectEntryBySlug(baseStrapiGetSlugQueryObjectFromRoute()) )
)

const attributes = baseStrapiGetAttributes(data)
const defaultOgImageUrl = baseStrapiGetAbsoluteFileUrl(attributes?.coverImage?.data?.attributes?.url, attributes?.coverImage?.data?.provider)
basePageSetHead(data, defaultOgImageUrl)
</script>

<style module>
.root {
  composes: container--modal from global;

  margin-bottom: calc(var(--unit--vertical) * 2);
}

.prevNext {
  margin-top: var(--unit--vertical);
}
</style>
